import React from "react";
import ProfileVideosLinks from "./profile-videos-links/profile-videos-links";

export default function ProfileVideoLinksTab() {
  return <ProfileVideosLinks />;
}
